import { render, staticRenderFns } from "./FollowUpFields.vue?vue&type=template&id=eaac2160"
import script from "./FollowUpFields.vue?vue&type=script&lang=js"
export * from "./FollowUpFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports